export interface CalendarParams {
  event_id: number;
  settlement_id: number;
  settlement_tipo: number;
  start_date: string;
  end_date: string;
  unit_status: number;
  utility_id: number;
  municipality: string;
}

export const CALENDAR_FILTER_KEYS = {
  EVENT_TYPE: 'eventType',
  SETTLEMENT_TYPE: 'settlementType',
  UNIT_STATUS: 'unitStatus',
  SETTLEMENT: 'settlement'
}
